import { useSelector } from "react-redux";
import useFeatureFlags from "hooks/useFeatureFlags";
import { REQUIRED_FEATURE_FLAGS } from "helpers/sf_constants";
import { bsh_isAdminUserDetailsPresent } from "helpers/sf_browser_storage_helper";

/**
 * Custom hook to manage SIC code targeting feature flags and account settings
 * @returns {Object} Object containing SIC targeting flags
 */
const useSicCodeTargeting = (props = {}) => {
    const [isFeatureFlagActive] = useFeatureFlags();

    const {
        current_account
    } = useSelector((state) => ({
        current_account: state.accounts.current_account
    }));

    const isAdminPresent = bsh_isAdminUserDetailsPresent();

    const isFfEnableSicCodeTargeting = isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_ENABLE_SIC_CODE_TARGETING);

    const isEnableSicEightTargeting = (
        (isFfEnableSicCodeTargeting && (current_account?.sic_eight_targeting_enabled || isAdminPresent))
    );

    const isEnableSicAndNaicsTargeting = (
        (isFfEnableSicCodeTargeting && (current_account?.sic_naics_targeting_enabled || isAdminPresent))
    );

    return {
        isEnableSicEightTargeting,
        isEnableSicAndNaicsTargeting,
        isFfEnableSicCodeTargeting
    };
};

export default useSicCodeTargeting;
